import {equalsAny, equalsAnyIgnoreCase} from './lang';
import {PRODUCT_CODES} from '../_constants/constants';
import {IfsProductCodesTypeMap, IfsProductType, ProductType} from '../_constants/types';

/**
 * Used to control IFS request forms for a selected branch
 */
const IFS_PRODUCT_CODES: IfsProductCodesTypeMap = {
  aml:        ['09800', '09980', '09981'],
  ebvsid:     ['06521'],
  eAml:       ['99980'],
  hawk:       ['06500'],
  avs:        ['08500'],
  bvs:        ['08900'],
  dirs:       ['02100', '411'],
  eDirs:      ['02199'],
  dirsLookup: ['02198']
};

/** Given a product code, this method will look up the corresponding key in the {@link IFS_PRODUCT_CODES} map */
export function getIfsProductName(code: string): IfsProductType {
  return Object.entries(IFS_PRODUCT_CODES).find(([, v]) => equalsAny(code, ...v))?.[0] as IfsProductType;
}

/** Basically a case-insensitive string comparison to see if the first param is found as a list item in the second param */
export function isAnyProduct(product: string, products: ProductType[]): boolean {
  return equalsAnyIgnoreCase(product, ...products);
}

/** Convenience method to check if the provided product code is any of the known MDS product codes */
export function isMds(productCode: string): boolean {
  return equalsAnyIgnoreCase(productCode, ...PRODUCT_CODES.mds);
}

/** Convenience method to check if the provided product code is any of the known AML product codes */
export function isAml(productCode: string): boolean {
  return equalsAnyIgnoreCase(productCode, ...IFS_PRODUCT_CODES.aml);
}

/** Convenience method to check if the provided product code is any of the known AVS product codes */
export function isAvs(productCode: string): boolean {
  return equalsAnyIgnoreCase(productCode, ...IFS_PRODUCT_CODES.avs);
}

/** Convenience method to check if the provided product code is any of the known BVS product codes */
export function isBvs(productCode: string): boolean {
  return equalsAnyIgnoreCase(productCode, ...IFS_PRODUCT_CODES.bvs);
}

/** Convenience method to check if the provided product code is any of the known HAWK product codes */
export function isHawk(productCode: string): boolean {
  return equalsAnyIgnoreCase(productCode, ...IFS_PRODUCT_CODES.hawk);
}

/** Convenience method to check if the provided product code is any of the known DIRS product codes */
export function isDirs(productCode: string): boolean {
  return equalsAnyIgnoreCase(productCode, ...IFS_PRODUCT_CODES.dirs);
}

/** Convenience method to check if the provided product code is any of the known DIRS Lookup product codes */
export function isDirsLookup(productCode: string): boolean {
  return equalsAnyIgnoreCase(productCode, ...IFS_PRODUCT_CODES.dirsLookup);
}

/** Convenience method to check if the provided product code is any of the known Model Report product codes */
export function isModelReport(productCode: string): boolean {
  return equalsAnyIgnoreCase(productCode, ...PRODUCT_CODES.modelReport);
}

/** Convenience method to check if the provided product code is any of the known ID Report product codes */
export function isIdReport(productCode: string): boolean {
  return equalsAnyIgnoreCase(productCode, ...PRODUCT_CODES.idReport);
}

/** Convenience method to check if the provided product code is any of the known ID Report product codes */
export function isIntactReport(productCode: string): boolean {
  return equalsAnyIgnoreCase(productCode, ...PRODUCT_CODES.intact);
}

/** Convenience method to check if the provided product code is any of the known EBVSID product codes */
export function isEbvsid(productCode: string): boolean {
  return equalsAnyIgnoreCase(productCode, ...IFS_PRODUCT_CODES.ebvsid);
}

